
import {
    PROCESS_SEAT,
    FETCH_SEATSIO_CONFIG
} from './actions.type'

import Vue from 'vue'
const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Basic ZjdlYWQ1MzctMGI2Ny00ZGMzLTkzZTQtMmE5OTk0YTIyYjVj'
}
const SEATSIO_API_URL = 'https://api.seatsio.net/'



const state = {
}

const getters = {
}
const actions = {
    [FETCH_SEATSIO_CONFIG](context, params) {
        return Vue.axios
            .get('/configuration/seatio')
            .then((response) => {
                return response.data.data
            })
    },
    async [PROCESS_SEAT](context, params) {
        return await Vue.axios
            .post(
                SEATSIO_API_URL + `events/${params.eventKey}/actions/${params.actionType}`,
                params.resource,
                { headers }
            )
            .then((response) => {
                return response
            })
    }
}
const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
